function ankerScroll(target) {
  var scrollTarget = target.offset().top;
  var headerHeight = $('header').height();
  $('html, body').stop().animate({
    scrollTop: scrollTarget
  }, 400)
}

  if (document.getElementById('interview')) {
    var scroll = document.querySelector('.curve');
    window.addEventListener('scroll', function(){
      var height = window.innerHeight / 4 * 4 * -1;
      var value = 1 + window.scrollY / height;
      scroll.style.transform = 'scaleY(' + value + ')';
    })
  }


// タブレットレイアウトをPCと統一
var metaDiscre = document.head.children;
var metaLength = metaDiscre.length;
if(window.outerWidth > 600 && window.outerWidth < 1100){
  for(var i = 0;i < metaLength;i++){
     var proper = metaDiscre[i].getAttribute('name');
      if(proper === 'viewport'){
        var dis = metaDiscre[i];
        dis.setAttribute('content','width=1200');
      }
  }
}

$(function() {

  //ローディングアニメーション
  function loadingAnimation(target) {
    var current_scrollY = window.scrollY;
    var indexLoading = $('#indexLoading');
    var loadingInner = $('#loadingInner');
    var videoMain = $('#videoMain');
    var loadingWrap = $('#loading');
    var loadingLogo = $('#loadingLogo');
    var loadingBg = $('#loadingBg');
    var loadingState = 0;
    var sectionHeight = [];
    var movieLoad = false;

    function loadingDelete(){
      loadingState = 1;
      indexLoading.addClass('loaded');
      $('body').removeClass('bind');
      setTimeout(function() {
        $('.img_logo').css('display', 'none');
      }, 1500);
    }

    function init(){
      /*$('body').addClass('bind');*/
      $('body').css('display', 'block');
      videoMain.on({
        'load': function(){
        movieLoad = true;
      }
    })

    setTimeout(function() {
      loadingLogo.addClass('load');
      setTimeout(function() {
        loadingLogo.removeClass('load');
        setTimeout(function() {
          loadingBg.addClass('load');
          loadingWrap.addClass('load')
          $('body').removeClass('bind');
        }, 1000);
      }, 1500);
      /*setTimeout(function() {
        setTimeout(function() {
          loadingDelete();
          if(loadingState == 0 && movieLoad){
            loadingDelete();
          }
        }, 2000);
      }, 3500);*/
    }, 300);

    setTimeout(function() {
      if(loadingState == 0){
        loadingDelete();
      }
    }, 10000);

  }

  init();

}

if (document.getElementById('index')) {
  loadingAnimation();
}


if (document.getElementById('index2')) {
  loadingAnimation();
}

function soundShifter(){
  var soundControll = $('#soundControll');
  /*const music = new Audio('assets/img/index2/sound.mp3');*/
  var bgmState = 0;

  function bgmControll(){
    if(bgmState == 0){
      soundControll.addClass('sound_on');
      bgmState = 1;
      $("#videoMain").prop('muted', false);
    }else{
      soundControll.removeClass('sound_on');
      bgmState = 0;
      $("#videoMain").prop('muted', true);
    }
  }

  function init(){
    soundControll.on({
      'click': function() {
        bgmControll();
      }
    })
  }

  init();

}

if (document.getElementById('index')) {
  soundShifter();
}

if (document.getElementById('index2')) {
  soundShifter();
}

function scrollAnimationSet(target) {
  const position = document.documentElement;
  const dotsIndicator = $('#dotsIndicator');
  const pcRolled = $('#pcRolled');
  const spRolled = $('#spRolled');
  const sectionConcept = $('#sectionConcept');
  const sectionProduct = $('#sectionProduct');
  const sectionNews = $('#sectionNews');
  let scrollSection;
  let wHeight = window.innerHeight;
  let sectionIntroduction;
  var cardItem = [];
  let sectionTop = [];
  let parallaxTarget = [];
  let parallaxTop = [];
  let parallaxPx = [];

  let preSetWidth = window.innerWidth;


  let indexSection = [];
  let indexSectionPosition = [];
  let indexSectonTheme = [];

  function setHeightProperty() {
    wHeight = window.innerHeight;
    position.style.setProperty('--wHeight', window.innerHeight);
    position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
    if(window.innerWidth != preSetWidth){
      position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
      preSetWidth = window.innerWidth;
    }

    if (document.getElementById('index2') || document.getElementById('interview')) {
      if(window.scrollY > 600){
        $('#soundWrapper').addClass('rolled');
      }else{
        $('#soundWrapper').removeClass('rolled');
      }
      $(".func-scroll-animation").each(function() {
        var imgPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > imgPos - windowHeight + windowHeight / 4) {
          $(this).removeClass('effect');
          $('#index2').removeClass('black');
        }else{
          $(this).addClass('effect');
          $('#index2').addClass('black');
        }
      });
    }

    requestAnimationFrame(setProperties);

  }


  function setProperties() {
    var windowHeight = $(window).height();
    position.style.setProperty('--scroll', window.scrollY);
    position.style.setProperty('--scrollPx', window.scrollY + 'px');

    // 黒背景時にヘッダーの色変え
    if (document.getElementById('bgBlackStart')) {
      if(window.scrollY > $('#bgBlackStart').offset().top){
        $('header').addClass('white');
      }else{
        $('header').removeClass('white');
      }
    }

    if (document.getElementById('bgBlackEnd')) {
      if(window.scrollY > $('#bgBlackEnd').offset().top){
        $('header').addClass('black');
      }else{
        $('header').removeClass('black');
      }
    }

    // 黒背景時にヘッダーの色変え
    if (document.getElementById('bgBlackStart2')) {
      if(window.scrollY > $('#bgBlackStart2').offset().top){
        $('header').addClass('white2');
      }else{
        $('header').removeClass('white2');
      }
    }

    if (document.getElementById('bgBlackEnd2')) {
      if(window.scrollY > $('#bgBlackEnd2').offset().top){
        $('header').addClass('black2');
      }else{
        $('header').removeClass('black2');
      }
    }

    if(window.scrollY > $('footer').offset().top - windowHeight / 2){
      $('#footerBg').addClass('display');
      $('header').addClass('f_white');
      $('header').removeClass('black');
      $('header').removeClass('black2');
    }else{
      $('#footerBg').removeClass('display');
      $('header').removeClass('f_white');
    }

    setHeightProperty();

  }

  function init() {
    var timer = false;
    setProperties();
    position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
  }

    init();

  }

  scrollAnimationSet($('article'));


  // ハンバーガーメニューの開閉
  function humMenuControll(target) {
    var header = $('header');
    var humMenuState = 0;
    var humMenuButton = $('#humButton button');
    var fadeBox = [];

    function hummenuMove() {
      if (humMenuState == 0) {
        target.addClass('open');
        header.addClass('hum_open');
        setTimeout(function() {
          target.find('.fade_box').addClass('display');
          /*target.find('.fade_box').each(function(index) {
            fadeBox[index] = $(this);
            var duration = 100 * index;
            setTimeout(function() {
              fadeBox[index].addClass('display');
            }, duration);
          });*/
        }, 300);
        humMenuState = 1;
      } else {
        target.find('.fade_box').removeClass('display');
        humMenuState = 0;
        header.removeClass('hum_open');
        setTimeout(function() {
          target.removeClass('open');
          /*target.find('.fade_box').each(function(index) {
            $(this).removeClass('display');
          });*/
        }, 300);
      }
    }

    function init() {
      humMenuButton.on({
        'click': function() {
          hummenuMove();
        }
      })
    }

    init();
  }

  humMenuControll($('#hummenu'));

  //トップに戻るボタン
  function returnTop(){
    const time = 300;
    const scrollButton = document.querySelector('#scrollTop');
    const returnTop = document.querySelector('#returnTop');
    scrollButton.addEventListener( 'click' , scrollTop );
    returnTop.addEventListener( 'click' , scrollTop );
    function scrollTop(){
      $('article').stop().animate({ opacity: 0 }, time, function() {
          window.scroll({top: 0, behavior: 'instant'});
          $('article').stop().animate({ opacity: 1 }, time);
      });
    };
  }

  /* ログインページの切り替えレイアウト */
  function switchLoginFunction(){
    var loginLayout = $('#login');
    var resetLayout = $('#reset');
    var resetPassword = $('#resetPassword');
    var loginBack = $('#loginBack');
    var urlHash = location.hash;
    var switchState = 0;

    function switchLogin(){
      if(switchState != 0){
        $('#footerBg').animate({opacity: 0}, 1);
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'block'});
            resetLayout.css({'display': 'none'});
            $("#contentSwitcher").css({'display': 'block'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400, function(){
                $('#footerBg').animate({opacity: 1}, 1);
              });
            }, 50);
        });
      }
    }

    function switchReset(){
      $('#footerBg').animate({opacity: 0}, 1);
      $('#contentSwitcher').animate({opacity:0}, 400, function(){
          loginLayout.css({'display': 'none'});
          resetLayout.css({'display': 'block'});
          $("#contentSwitcher").css({'display': 'block'});
          setTimeout(function() {
            $("#contentSwitcher").animate({opacity: 1}, 400, function(){
              $('#footerBg').animate({opacity: 1}, 1);
            });
          }, 50);
          switchState = 1;
      });
    }

    function init(){
      if(urlHash.indexOf('recover') > -1){
        switchReset();
      }else{
        switchLogin();
      }
      resetPassword.on({
        'click': function() {
          event.preventDefault();
          switchReset();
        }
      });

      loginBack.on({
        'click': function() {
          event.preventDefault();
          switchLogin();
        }
      });

    }

    init();

  }

  if (document.getElementById('contentSwitcher')) {
    switchLoginFunction();
  }


  /* 住所一覧ページの切り替えレイアウト */
  function switchAddressFunction(){
    var addressContentWrap = $('#addressContentWrap');
    var wrapperList = $('#wrapperList');
    var wrapperAdd = $('#wrapperAdd');
    var addressList = $('#addressList');
    var addressEdit = $('#addressEdit');
    var adminBar = $('#adminBar');
    var editbutton = [];
    var editId = [];


    function switchList(){
      adminBar.removeClass('mode-edit').addClass('mode-list');
      window.scroll({top: 0, behavior: 'smooth'});
      addressContentWrap.animate({opacity:0}, 400, function(){
        $('.content_wrapper').css({'display': 'none'});
        wrapperList.css({'display': 'block'});
        addressContentWrap.css({'display': 'block'});
        setTimeout(function() {
          addressContentWrap.animate({opacity: 1}, 400);
        }, 50);
      });
    }

    function switchAdd(){
      adminBar.addClass('mode-edit').removeClass('mode-list');
      window.scroll({top: 0, behavior: 'smooth'});
      addressContentWrap.animate({opacity:0}, 400, function(){
          $('.content_wrapper').css({'display': 'none'});
          wrapperAdd.css({'display': 'block'});
          addressContentWrap.css({'display': 'block'});
          setTimeout(function() {
            addressContentWrap.animate({opacity: 1}, 400);
          }, 50);
      });
    }

    function switchEdit(e){
      adminBar.addClass('mode-edit').removeClass('mode-list');
      window.scroll({top: 0, behavior: 'smooth'});
      addressContentWrap.animate({opacity:0}, 400, function(){
          $('.content_wrapper').css({'display': 'none'});
          $('#' + editId[e]).css({'display': 'block'});
          addressContentWrap.css({'display': 'block'});
          setTimeout(function() {
            addressContentWrap.animate({opacity: 1}, 400);
          }, 50);
      });
    }

    function init(){
      addressList.on({
        'click': function() {
          event.preventDefault();
          switchList();
        }
      });

      addressEdit.on({
        'click': function() {
          event.preventDefault();
          switchAdd();
        }
      });

      $.each($('article').find('.btn_edit'), function(index) {
        editbutton[index] = $(this);
        editId[index] = $(this).attr('formId');
        editbutton[index].on({
          'click': function() {
            console.log(editId[index]);
            switchEdit(index);
          }
        });
      });

    }

    init();

  }

  if (document.getElementById('addressContentWrap')) {
    switchAddressFunction();
  }


  // 商品詳細ページ 数量インプットの操作
  function controllBuyingQuantity(target){
    var minusButton = target.find('.minus');
    var plusButton = target.find('.plus');
    var quantityInput = target.find('input[type=text]');
    var quantityNum;

    function controllQuantity(vector){
      quantityNum = quantityInput.val();
      if(vector == 1){
        quantityInput.attr('value', Number(quantityNum) + 1);
      }else{
        if(quantityNum != 1){
          quantityInput.attr('value', Number(quantityNum) - 1);
        }
      }
    }

    function init(){

      minusButton.on({
        'click': function() {
          event.preventDefault();
          controllQuantity(-1);
        }
      });
      plusButton.on({
        'click': function() {
          event.preventDefault();
          controllQuantity(1);
        }
      });

    }

    init();

  }

  if (document.getElementById('quantityWrap')) {
    controllBuyingQuantity($('#quantityWrap'));
  }


  // 商品詳細ページ トグルレイアウト
  function itemDetailToggle(){
    var toggleItem = [];
    var toggleButton = [];
    var toggleContents = [];
    var toggleState = [];
    var ankerButton = [];
    var cartAnker = [];
    var cartNoteList = $('#cartNoteList');

    function toggleMove(e) {
      if ( toggleState[e] == 0 ) {
        toggleButton[e].addClass('active');
        var buttonHeight = toggleButton[e].outerHeight();
        var tagetHeight = toggleContents[e].outerHeight();
        toggleItem[e].css({
          'height': buttonHeight + tagetHeight + 'px'
        });
        toggleState[e] = 1;
      } else {
        var buttonHeight = toggleButton[e].outerHeight();
          toggleItem[e].css({
            'height': buttonHeight + 1 + 'px'
          });
          setTimeout(function() {
            toggleButton[e].removeClass('active');
          }, 300);
        toggleState[e] = 0;
      }
    }

    function ankerMove(e){
      var scrollHeight = $(cartAnker[e]).offset().top;
      var headerHeight = $('header').outerHeight();
      $("html, body").animate({
        scrollTop: scrollHeight - headerHeight
      }, 500);
      setTimeout(function() {
        if ( toggleState[e + 1] == 0 ) {
          $(cartAnker[e]).find('button').click();
        }
      }, 500);

    }


    function init(){
      $.each($('article').find('.toggle_item'), function(index) {
        console.log('index:' + index);
        toggleItem[index] = $(this);
        toggleButton[index] = $(this).find('button');
        toggleContents[index] = $(this).find('.toggle_content_new');
        $(this).css({'height': toggleButton[index].outerHeight() + 1 + 'px'});
        toggleState[index] = 0;
        toggleButton[index].on({
          'click': function() {
            toggleMove(index);
          }
        });
      });

      $.each(cartNoteList.find('button'), function(index) {
        ankerButton[index] = $(this);
        cartAnker[index] = $(this).attr('prop');
        ankerButton[index].on({
          'click': function() {
            event.preventDefault();
            ankerMove(index);
          }
        });
      });

    }

    init();
  }

  if (document.getElementById('productDetail')) {
    itemDetailToggle();
  }

  // 商品詳細レイアウト サムネイルの切り替え
  function thumbSwitcher(target){
    let thumbButton = [];
    let thumbSrc = [];
    let thumbAlt = [];
    let thumbSrcSet = [];
    let thumbBox = target.find('.thumb_img');
    let caption = target.find('.caption');
    let thumbImage = thumbBox.find('img');
    const time = 300;

    function switchImage(num){
      thumbBox.stop().animate({ opacity: 0 }, time, function() {
          thumbImage.attr('src', thumbSrc[num]);
          thumbImage.attr('srcset', thumbSrcSet[num]);
          $('.active_thumb').removeClass('active_thumb');
          thumbButton[num].addClass('active_thumb');
          caption.html(thumbAlt[num]);
          thumbBox.stop().animate({ opacity: 1 }, time);
      });
    }

    function thumbHeightControll(){
      var thumbHeight = thumbImage.outerHeight();
      /*$('#thumnails').css({'max-height': thumbHeight + 'px'});*/
      /*requestAnimationFrame(thumbHeightControll);*/
    }

    function init(){
      thumbHeightControll();
      $.each(target.find('button'), function(index) {
        thumbButton[index] = $(this);
        thumbSrc[index] = $(this).find('img').attr("src");
        thumbSrcSet[index] = $(this).find('img').attr("srcset");
        thumbAlt[index] = $(this).find('img').attr("alt");
        thumbButton[index].on({
          'click': function() {
            switchImage(index);
          }
        });
      });
      $(window).on({
        'resize': function(){
          thumbHeightControll();
        }
      });
    }

    init();

  }

  if (document.getElementById('thumbnails01')) {
    thumbSwitcher($('#thumbnails01'));
  }

  if (document.getElementById('thumbnails02')) {
    thumbSwitcher($('#thumbnails02'));
  }

  // 商品詳細 バリエーション毎の価格切り替え
  function variationSwitchControll(target){
    console.log('variationSwitchControll');
    let variationSelector = target.find('.variation_selector');
    let totonoiBox = target.find('.totonoi');
    let priceDisplay = target.find('.price_display span');

    function variationCahngeDisplay(price, i){
      priceDisplay.html(price);
      if(i != 0){
        totonoiBox.css({'opacity': '1'});
      }else{
        totonoiBox.css({'opacity': '0.2'});
      }
    }

    function init(){
      variationSelector.on({
        'change': function(){
          var selectedValue = variationSelector.find('option:selected').attr('price');
          var setValue = variationSelector.find('option:selected').attr('set');
          variationCahngeDisplay(selectedValue, setValue);
        }
      });
    }

    init();

  }

  if (document.getElementById('cartWrapper01')) {
    variationSwitchControll($('#cartWrapper01'));
  }

  if (document.getElementById('cartWrapper02')) {
    variationSwitchControll($('#cartWrapper02'));
  }

  //商品詳細ページ サイズバリエーションボタン
  function sizeVariationControll(target){
    var currentSize = $('#currentSize');
    var currentPrice = $('#currentPrice');
    var sizeSelectBox = $('#sizeSelectBox');
    var sizeButton = [];
    var sizeName = [];
    var sizePrice = [];


    function sizeChange(e){
      currentSize.text(sizeName[e] + 'サイズ');
      currentPrice.text(sizePrice[e]);
      sizeSelectBox.val(sizeButton[e].val());
    }

    function init(){
      $.each(target.find('input[type=radio]'), function(index) {
        console.log('index:' + index);
        sizeButton[index] = $(this);
        sizeName[index] = $(this).attr('varName');
        sizePrice[index] = $(this).attr('price');
        sizeButton[index].on({
          'click': function() {
            sizeChange(index);
          }
        });
      });
    }

    init();

  }

  if (document.getElementById('sizeSelect')) {
    sizeVariationControll($('#sizeSelect'));
  }

  //カートページ 購入個数の増減
  function controllProductQuantity(target){
    var minusButton = [];
    var plusButton = [];
    var quantityInput = [];
    var reloadButton = [];
    var quantityNum;

    function controllQuantity(num, vector){
      quantityNum = quantityInput[num].val();
      if(vector == 1){
        quantityInput[num].attr('value', Number(quantityNum) + 1);
        reloadButton[num].click();
      }else{
        if(quantityNum != 1){
          quantityInput[num].attr('value', Number(quantityNum) - 1);
          reloadButton[num].click();
        }
      }
    }

    function init(){
      $.each(target.find('.cart_item'), function(index) {
        minusButton[index] = $(this).find('.minus');
        plusButton[index] = $(this).find('.plus');
        quantityInput[index] = $(this).find('input[type="number"]');
        reloadButton[index] = $(this).find('.reload_button');
        minusButton[index].on({
          'click': function() {
            controllQuantity(index, -1);
          }
        });
        plusButton[index].on({
          'click': function() {
            controllQuantity(index, 1);
          }
        });
      });

    }

    init();

  }

  if (document.getElementById('cartItem')) {
    controllProductQuantity($('#cartItem'));
  }

  //FAQページ内の、トグル制御

  function faqToggle(target) {
    var toggleItem = [];
    var toggleButton = [];
    var toggleContents = [];
    var toggleHeight = [];
    var toggleState = [];
    var toggleTitleTxt = [];
    var toggleContentsTxt = [];
    var faqSearch = $('#faqSearch');
    var faqFlex = $('#faqFlex');
    var windowW = window.innerWidth;

    function toggleMove(e) {
      if ( toggleState[e] == 0 ) {
        toggleItem[e].addClass('active');
        var buttonHeight = toggleButton[e].outerHeight();
        var targetHeight = toggleHeight[e].outerHeight();
        toggleItem[e].css({
          'height': buttonHeight + targetHeight + 'px'
        });
        toggleContents[e].css({
          'height': targetHeight + 'px'
        });
        toggleState[e] = 1;
      } else {
        toggleItem[e].removeClass('active');
        var buttonHeight = toggleButton[e].outerHeight();
          toggleItem[e].css({
            'height': buttonHeight + 'px'
          });
          toggleContents[e].css({
            'height': '0px'
          });
        toggleState[e] = 0;
      }
    }

    function setToggleHeight(){
      $.each(target.find('.toggle_item'), function(index) {
        toggleItem[index].removeClass('active');
        toggleItem[index] = $(this);
        toggleButton[index] = $(this).find('.toggle_button');
        toggleContents[index] = $(this).find('.toggle_contents');
        toggleHeight[index] = $(this).find('.contents_inner');
        toggleContents[index].css({'height': 0 + 'px'});
        $(this).css({'height': toggleButton[index].outerHeight() + 2 + 'px'});
        toggleState[index] = 0;
      });
    }

    function init() {
      $.each(target.find('.toggle_item'), function(index) {
        toggleItem[index] = $(this);
        toggleButton[index] = $(this).find('.toggle_button');
        toggleContents[index] = $(this).find('.toggle_contents');
        toggleHeight[index] = $(this).find('.contents_inner');
        $(this).css({'height': toggleButton[index].outerHeight() + 2 + 'px'});
        toggleState[index] = 0;
        toggleTitleTxt[index] = toggleButton[index].text();
        toggleContentsTxt[index] = toggleContents[index].text();
        toggleButton[index].on({
          'click': function() {
            toggleMove(index);
          }
        });
      });


      $(window).on(
        'resize', function() {
          setToggleHeight();
        }
      );
    }

    init();

  }

  if (document.getElementById('faqWrap')) {
    faqToggle($('body'));
  }

  //アバウトページ ローディングアニメーション
  function aboutPageLoading(){
    setTimeout(function() {
      $('#spRolled').addClass('loaded');
      setTimeout(function() {
        $('#aboutTtl').addClass('display');
      }, 500);
    }, 300);
  }

  if (document.getElementById('interview')) {
    aboutPageLoading();
  }

  function aboutScrollIndicator(){
    console.log('aboutScrollIndicator');
    var contensBox = $('#contensBox');
    var indicatorInner = $('#indicatorInner');
    var percentBox = $('#percentBox');
    var contentsOffset;
    var footerOffset;
    var offsetHeight = window.scrollY;
    var percent;

    function indicatorSet(){
      var contentsOffset = contensBox.offset().top;
      var footerOffset = $('footer').offset().top;
      var contentsHeight = footerOffset - contentsOffset;
      var scrollHeight = window.scrollY - contentsOffset + window.innerHeight;
      percentNum = Math.round(scrollHeight / contentsHeight * 100);
      percent = scrollHeight / contentsHeight * 100;
      indicatorInner.css({'width': percent + '%'});
      requestAnimationFrame(indicatorSet);
      if(percentNum < 10){
        percentBox.text('0' + percentNum);
      }else{
        if(percentNum < 100){
          percentBox.text(percentNum);
        }
      }
    }

    function init(){
      indicatorSet();
    }

    init();

  }

  if (document.getElementById('interview')) {
    /*aboutScrollIndicator();*/
  }

  // アバウトページ スマホ版目次
  function aboutIndexSp(){
    var indexButton = $('#indexButton');
    var spIndex = $('#spIndex');
    var toggleState = 0;

    function indextoggle(){
      if(toggleState == 0){
        spIndex.addClass('display');
        toggleState = 1;
      }else{
        spIndex.removeClass('display');
        toggleState = 0;
      }
    }

    function init(){
      indexButton.on({
        'click': function(){
          indextoggle();
        }
      });
      spIndex.find('button').each(function(index) {
        $(this).on({
          'click': function(){
            indextoggle();
          }
        });
      });
    }

    init();

  }

  if (document.getElementById('interview')) {
    aboutIndexSp();
  }

  /* お問い合わせフォームのGAS連動とバリデーション */
  function setMyForm(target){
    console.log('setMyForm');
    var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
    var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
    var errorCount = 0;
    var submitWrap = $('#submit');
    var confirmButton = $('#confirm');
    var submitButton = $('#submitButton');
    var contactBackButton = $('#contactBackButton');
    var items = []; //チェック対象となるテキスト入力要素を格納した配列

    //項目チェックする
    var checkAll = function(){
      errorCount = 0;

      //input,textareaのチェック
      for( var i=0; i<items.length; i++ ){
        if( items[i].prop('isSuccess') == false ){
          errorCount++;
        };
      };

      console.log('errorCount:' + errorCount);

      if( errorCount == 0 ){
        submitButton.attr('disabled', false);
        submitButton.removeClass('disabled');
      }else{
        submitButton.attr('disabled', true);
        submitButton.addClass('disabled');
      };
    };

    //エラーメッセージの追加
    var addErrorMessage = function(selector, msg){
      removeErrorMessage(selector);
      selector.parent('div').append('<span class="error '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
      selector.addClass(ERROR_INPUT_CLASSNAME);
    };

    //エラーメッセージの削除
    var removeErrorMessage = function(selector){
      var msgSelector = selector.parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
      if( msgSelector.length != 0 ){
        msgSelector.remove();
        selector.removeClass(ERROR_INPUT_CLASSNAME);
      };
    };

    //input,textareaの未入力チェック
    var checkEmptyText = function(selector, msg){
      if( selector.val() == '' ||  selector.val() == null){
        addErrorMessage(selector, msg);
        selector.prop('isSuccess', false);
      }else{
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      };
    };

    var emptyThrough = function(selector){
      if( selector.val() == '' ||  selector.val() == null){
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      }
    };

    //radioの未入力チェック
    var checkRadioBox = function(selector, msg){
      if( selector.prop("checked")){
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
        submitWrap.removeClass('disabled');
      }else{
        addErrorMessage(selector, msg);
        selector.prop('isSuccess', false);
        submitWrap.addClass('disabled');
      };
    };

    //文字列のフォーマットチェック
    function checkFormatText(selector, _mode, msg){
      var value = selector.val();
      switch(_mode){
        //全角のみ
        case 0:
          if(value.match(/^[^ -~｡-ﾟ]*$/)){
            selector.prop('isSuccess', true);
            removeErrorMessage(selector);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //ふりがなのみ
        case 1:
          if(value.match(/^[\u3040-\u309F]+$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //半角数字とハイフンのみ
        case 2:
        if(value.match(/^[0-9\-]+$/) || value.length < 1){
          selector.prop('isSuccess', true);
        }else{
          selector.prop('isSuccess', false);
        };
        break;
        //メールアドレスかどうか
        case 3:
          if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
      };
      if( selector.prop('isSuccess') == false ){
        addErrorMessage(selector, msg);
      }else{
        removeErrorMessage(selector);
      };
    };

    //初期設定
    var init = function(){
      target.find('input[type=button]').attr('disabled', true);
      //submitイベントの設定
      target.on({
        'submit': function(){
          checkAll();
        }
      });
      //input要素を配列に格納
      items = [
        target.find('input[name="username"]'), //0 氏名
        target.find('input[name="usermail"]'), //1 メールアドレス
        target.find('input[name="telnumber"]'), //2 電話番号
        target.find('select[name="category"]'), //3 お問い合わせ種別
        target.find('textarea[name="content"]'), //4 お問い合わせ内容
      ];

      //input要素のプロパティを設定
      $.each(items, function(index){
        items[index].prop('isSuccess', false);
      });

      //enterキーでsubmitしてしまうのを防止する
      target.find('input[type=text]').on({
        'keypress': function(e){
          if( (e.keyCode == 13) ) return false;
        }
      });
      //0 氏名
      items[0].on({
        'blur': function(){
          checkEmptyText( items[0], '※氏名を入力してください。' );
          checkAll();
        }
      });
      //2 メールアドレス
      items[1].on({
        'blur': function(){
          checkEmptyText( items[1], '※メールアドレスをご入力ください。' );
          if( items[1].prop('isSuccess') ) checkFormatText( items[1], 3, '※アドレスの形式をご確認ください' );
          checkAll();
        }
      });
      //2 電話番号
      items[2].on({
        'blur': function(){
          checkEmptyText( items[2], '※電話番号を入力してください。' );
          if( items[2].prop('isSuccess') ) checkFormatText( items[2], 2, '※電話番号は数字で入力してください。');
          checkAll();
        }
      });
      //3 お問い合わせ種別
      items[3].on({
        'change': function(){
          checkEmptyText( items[3], '※項目を選択してください' );
          checkAll();
        }
      });
      //4 お問い合わせ内容
      items[4].on({
        'blur': function(){
          checkEmptyText( items[4], '※お問い合わせ内容を入力してください' );
          checkAll();
        }
      });

      //5 プラポリへの同意
      $(target.find('input[name=privacy]')).on({
        'click': function(){
          var privacyState = $('input[name="privacy"]:checked').val();
          if(privacyState == 1){
            confirmButton.removeClass('disabled');
          }else{
            confirmButton.addClass('disabled');
          }
        }
      });
      confirmButton.on({
        'click': function(){
          checkEmptyText( items[0], '※氏名を入力してください。' );
          checkEmptyText( items[1], '※メールアドレスをご入力ください。' );
          checkEmptyText( items[2], '※電話番号を入力してください。' );
          checkEmptyText( items[3], '※項目を選択してください' );
          checkEmptyText( items[4], '※お問い合わせ内容を入力してください' );
          checkAll();
          if( errorCount == 0 ){
            contentCheck();
          }else{
            alert('入力内容に不備があります。入力内容を確認いただき、再度確認ボタンを押してください。');
            var scrollHeight = $('article').offset().top;
            $("html, body").animate({
              scrollTop: scrollHeight
            }, 300);
          };
        }
      })
      contactBackButton.on({
        'click': function(){
          contentBack();
        }
      })
      submitButton.on({
        'click': function(){
          processOrderContent();
        }
      })
    };

    function contentBack(){
      $('#footerBg').animate({opacity: 0}, 1);
      $('article').animate({opacity:0}, 400, function(){
          $('#contactConfirm').css({'display': 'none'});
          $('#contactInput').css({'display': 'block'});
          $('#contactTitle').html('お問い合わせ');
          window.scroll({top: 0, behavior: 'instant'});
          setTimeout(function() {
            $("article").animate({opacity: 1}, 400, function(){
              $('#footerBg').animate({opacity: 1}, 1);
            });
          }, 50);
      });
    }

    function contentCheck(){
      var userName = target.find('input[name="username"]').val();
      var userMail = target.find('input[name="usermail"]').val();
      var telNumber = target.find('input[name="telnumber"]').val();
      var category = target.find('select[name="category"]').val();
      var content = target.find('textarea[name="content"]').val();
      $('#footerBg').animate({opacity: 0}, 1);
      $('article').animate({opacity:0}, 400, function(){
          $('#contactConfirm').css({'display': 'block'});
          $('#contactInput').css({'display': 'none'});
          $('#userNameInput').html(userName);
          $('#userMailInput').html(userMail);
          $('#phoneNumberInput').html(telNumber);
          $('#phoneNumberInput').html(telNumber);
          $('#categoryInput').html(category);
          $('#categoryInput').html(category);
          $('#contentInput').html(content);
          window.scroll({top: 0, behavior: 'instant'});
          setTimeout(function() {
            $("article").animate({opacity: 1}, 400, function(){
              $('#footerBg').animate({opacity: 1}, 1);
            });
          }, 50);
      });
      /*processOrderContent();*/
    }

    function processOrderContent(){
      var userName = target.find('input[name="username"]').val();
      var userMail = target.find('input[name="usermail"]').val();
      var telNumber = target.find('input[name="telnumber"]').val();
      var category = target.find('select[name="category"]').val();
      var content = target.find('textarea[name="content"]').val();
      submitButton.css({'pointer-events': 'none'});
      event.preventDefault();
      $.ajax({
        url: "https://docs.google.com/forms/u/2/d/e/1FAIpQLSeP6OWW8gkPd6mHJoinR-rVY_lC8jkL_H7aPSccGIxuHrVCCA/formResponse",
        data: {
          "entry.685030940": userName,
          "entry.1439734108": userMail,
          "entry.1462748142": telNumber,
          "entry.297743535": category,
          "entry.670769512": content
        },
      type: "POST",
      dataType: "xml",
      statusCode: {
          0: function () {
            setTimeout(function() {
              location.href = 'https://' + location.hostname + '/pages/complete'
            }, 500);
          },
          200: function () {
            alert('メッセージ送信に失敗しました。お手数ではございますが、時間を置いてもう一度お試しください。');
            setTimeout(function() {
              location.href = 'https://' + location.hostname + '/';
            }, 500);
          }
        }
    });
  }

    init();

  };

  if (document.getElementById('contact')) {
    setMyForm($('#formWrap'));
  }

  if (document.getElementById('useageSlider')) {
    /*console.log('useageSlider');*/
    $('#useageSlider').slick({
  	accessibility: false,
  	infinite: true,
  	dots: false,
  	slidesToShow: 4,
  	centerMode: false,
  	autoplay: true,
  	speed: 600,
  	prevArrow: '<button id="slickPrevButton" class="comp-slider-caret prev-arrow"><span class="circle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.46 10.07"><polygon class="cls-1" points="6.46 1.41 5.04 0 0 5.04 5.04 10.07 6.46 8.66 2.83 5.04 6.46 1.41"/></svg></span></button>',
  	nextArrow: '<button id="slickNextButton"  class="comp-slider-caret next-arrow"><span class="circle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.46 10.07"><polygon class="cls-1" points="0 8.66 1.41 10.07 6.46 5.03 1.41 0 0 1.41 3.62 5.04 0 8.66"/></svg></span></button>',
  	responsive: [
  		{
  			breakpoint: 750,
  			settings: {
  				slidesToShow: 1,
  				centerPadding: '0',
  				centerMode: false,
  				autoplay: true,
  			}
  		}
  	]
  	});
  }

});
